import { Controller } from "@hotwired/stimulus";
import { dispatchStampEarn } from "../utils/stampEvents";

export default class extends Controller {
  static values = {
    stampAmount: Number,
    stampNewBalance: Number
  };

  declare stampAmountValue: number;
  declare stampNewBalanceValue: number;
  declare hasStampAmountValue: boolean;
  declare hasStampNewBalanceValue: boolean;

  connect() {
    this.hideAfterDelay();

    // Dispatch stamp earn event for navbar animation (e.g., daily login bonus)
    if (this.hasStampAmountValue && this.stampAmountValue > 0) {
      // Small delay to ensure navbar controller is ready
      setTimeout(() => {
        const newBalance = this.hasStampNewBalanceValue ? this.stampNewBalanceValue : undefined;
        dispatchStampEarn(this.stampAmountValue, newBalance ?? 0, 'daily_bonus');
      }, 100);
    }
  }

  hideAfterDelay() {
    setTimeout(() => {
      this.element.classList.add("opacity-0", "transition-opacity", "duration-300");
      setTimeout(() => {
        this.element.remove();
      }, 300);
    }, 5000);
  }

  close() {
    this.element.remove();
  }
}
